import type { FC } from "react";
import { ExpenseCategoryCard } from "web_myplann/Finances/Components/ExpenseCategoryCard";
import { EXPENSE_TYPE_ORDER } from "web_myplann/Finances/constants";
import type { ExpenseFormEntry } from "web_myplann/Finances/Forms/expenseEntrySchema";
import type { IndexedExpense } from "web_myplann/Finances/Helpers/groupExpensesByType";
import type { ClientFinancialPlanExpenseTypeEnum } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	groups: Record<
		ClientFinancialPlanExpenseTypeEnum,
		IndexedExpense<ExpenseFormEntry>[]
	>;
	onAdd: (type: ClientFinancialPlanExpenseTypeEnum) => void;
	onEdit: (index: number) => void;
	onRemove: (index: number) => void;
};

export const ExpenseCategoryList: FC<Props> = ({
	groups,
	onAdd,
	onEdit,
	onRemove,
}) => (
	<>
		{EXPENSE_TYPE_ORDER.map((type) => (
			<ExpenseCategoryCard
				key={type}
				type={type}
				items={groups[type]}
				onAdd={() => onAdd(type)}
				onEdit={onEdit}
				onRemove={onRemove}
			/>
		))}
	</>
);
